export default {
  "content": "<path d=\"M11.344 33.525l.012-.003.173.4c5.074-1.206 10.647 1.553 12.556 6.271l-2.338.63c-.77.207-1.615-.22-2.086-.866-1.53-2.098-4.404-3.181-7.02-2.477l-.011.004-.112-.275c-4.858.988-10.374-2.01-12.47-6.848l2.246-.559c.739-.184 1.585.282 2.078.955 1.602 2.19 4.46 3.394 6.972 2.768z\" fill=\"#00ECBB\"/><path d=\"M2.193 5.849h.012c2.594.21 4.87-1.35 5.611-3.647.228-.706.864-1.27 1.627-1.21l2.318.188c-.282 4.985-4.651 8.692-9.76 8.28H1.99l.204-3.611z\" fill=\"#AF64FF\"/><circle cx=\"12.739\" cy=\"19.185\" transform=\"rotate(29.49 12.74 19.185)\" fill=\"#FFCD00\" r=\"2.753\"/>",
  "attrs": {
    "width": "25",
    "height": "41",
    "viewBox": "0 0 25 41",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};